//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import abstract from '@/assets/imgs/blog-abstract.svg';
import footerAbstract from '@/assets/imgs/blog-footer-abstract.svg';
import thumbnail from '@/assets/imgs/mindshare.png';

export default {
  name: 'KnockBlog',

  async asyncData({ $wpJson }) {
    let posts = [];
    let bodyPosts = [];
    let categories = [];
    const catNames = [];
    const count = 7;

    try {
      ({ posts } = await $wpJson.posts.getPreviews({
        perPage: count
      }));

      bodyPosts = posts.slice(1);
    }
    catch (err) {
      console.error(err);
    }

    try {
      (categories = await $wpJson.posts.getCats());
    }
    catch (err) {
      console.error(err);
    }

    categories = categories.filter((cat) => cat.count !== 0);

    categories.some((cat, id) => cat.id === 1 && categories.unshift(
      categories.splice(id, 1)[0]
    ));

    categories.forEach((cat) => {
      catNames[cat.id] = cat.name;
    });

    categories[0].name = 'All Posts';

    return {
      posts, bodyPosts, categories, catNames, count
    };
  },

  data() {
    return {
      category: 1,
      active: 'active',
      page: 1,
      search: '',
      footerAbstract,
      thumbnail
    };
  },

  computed: {
    headerBg() {
      return `background:  url("${abstract}") no-repeat right top/auto 100% #131212`;
    }
  },

  methods: {
    async getPosts() {
      if (!(this.posts.length % this.count)) {
        let newPosts = [];
        this.page += 1;

        try {
          (newPosts = await this.$wpJson.posts.getPreviews({
            perPage: this.count,
            page: this.page,
            categories: this.category
          }));

          this.posts = this.posts.concat(newPosts.posts);

          this.bodyPosts = this.posts.slice(1);

          if (newPosts.posts.length !== this.count) {
            this.page = 0;
          }
        }
        catch (err) {
          // console.error(err);
          this.page = 0;
        }
      }
      else {
        this.page = 0;
      }
    },

    async setCat(cat) {
      this.page = 1;
      this.category = cat;
      let newPosts = [];

      try {
        (newPosts = await this.$wpJson.posts.getPreviews({
          perPage: this.count,
          page: this.page,
          categories: cat
        }));

        this.posts = [];

        this.posts = this.posts.concat(newPosts.posts);

        this.bodyPosts = this.posts.slice(1);
      }
      catch (err) {
        console.error(err);
      }
    },

    toDate(string) {
      const today = new Date(string);
      const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return `${month[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`;
    },

    getThumbnail() {
      if (this.posts[0]?.thumbnail?.source_url) {
        return this.posts[0].thumbnail.source_url;
      }

      return this.thumbnail;
    },

    searchPosts(e) {
      e.preventDefault();
      this.$router.push(`/search?q=${encodeURIComponent(this.search)}`);
    }
  }
};
